import * as React from 'react';
import { StepLabelProps, StepLabel } from '@material-ui/core';

export type DSStepLabelProps = StepLabelProps;

export function DSStepLabel(props: DSStepLabelProps): JSX.Element {
    return <StepLabel {...props}>{props.children}</StepLabel>;
}
DSStepLabel.displayName = 'DSStepLabel';
